import apiFetch from '../apiFetch'

export default function (formState) {
  return apiFetch({ endPoint: 'login/recoverpassword', method: 'POST', body: formState })
}
